var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Styles from './payment-register-styles.scss';
import { ButtonKVBase, Logo } from '@/presentation/components';
import { StripeIcon } from '@/presentation/components/icons';
const PaymentRegister = ({ getInfo, getStripePage }) => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const { showCustomError } = useCustomToast();
    const client = searchParams.get('client');
    const plan = searchParams.get('plan');
    const getInfoPay = (idClient, plan) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            setLoading(true);
            const infopay = yield getInfo.getPaymentInfoFromAdmin({
                idClient: idClient,
                plan,
                fromAdmin: true
            });
            setLoading(false);
            if (((_a = infopay === null || infopay === void 0 ? void 0 : infopay.items) === null || _a === void 0 ? void 0 : _a.length) === 0 || !(infopay === null || infopay === void 0 ? void 0 : infopay.items)) {
                showCustomError('Error', 'Error getting payment info');
                setPaymentData(null);
            }
            else {
                const amountFormated = infopay.items.map(item => {
                    return Object.assign(Object.assign({}, item), { priceStripe: Object.assign(Object.assign({}, item.priceStripe), { unit_amount: item.priceStripe.unit_amount / 100 }) });
                });
                setPaymentData(Object.assign(Object.assign({}, infopay), { items: amountFormated }));
            }
        }
        catch (error) {
            setLoading(false);
        }
    });
    const getPage = (paymentData) => __awaiter(void 0, void 0, void 0, function* () {
        const dataToSend = {
            items: paymentData === null || paymentData === void 0 ? void 0 : paymentData.items,
            userClient: {
                id: Number(client),
                subCognitoId: '',
                email: ''
            }
        };
        setLoading(true);
        const res = yield getStripePage.getPageAdmin(dataToSend);
        setLoading(false);
        if (res && res.url) {
            window.location.href = res.url;
        }
    });
    useEffect(() => {
        if (client && plan) {
            getInfoPay(Number(client), plan);
        }
    }, [client, plan]);
    useEffect(() => {
        if (paymentData) {
            console.log({
                paymentData
            });
        }
    }, [paymentData]);
    return (React.createElement("div", { className: Styles.paymentRegisterComp },
        React.createElement("div", { className: Styles.content },
            React.createElement(Logo, null),
            React.createElement(ButtonKVBase, { onClick: () => {
                    if (paymentData) {
                        getPage(paymentData);
                    }
                }, btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", type: "button", loading: loading }, "Go to payment"),
            React.createElement("div", { className: Styles.stripeMessage },
                React.createElement("h4", null, "** By continuing you will be redirect to the Stripe payment page."),
                React.createElement("div", { className: Styles.stripe },
                    React.createElement("span", null, "Secured by"),
                    React.createElement("span", { className: Styles.logo },
                        React.createElement(StripeIcon, null)))))));
};
export default PaymentRegister;
